<p-toast key="ajustement"></p-toast>

<p-card *ngIf="!EstCharge()">
    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 col-12 text-center">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </div>
</p-card>



<div #contenu *ngIf="EstCharge()">

    <div class="col-12">
        <p-card>
            <div class="fluid formgrid grid">
                <div class="flex flex-column gap-2 col-12 md:col-6 lg:col-4">
                    <label for="lastname">Date</label>
                    <p-calendar appendTo="body" showIcon=true [(ngModel)]="ajustement.date" dateFormat="yy-mm-dd" [yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040"></p-calendar>
                    <small class="p-error" *ngIf="submitted && !ajustement.date">La date est obligatoire.</small>
                </div>
                <div class="flex flex-column gap-2 col-12 md:col-6 lg:col-4">
                    <label for="chauffeur">Nb KM ancien compteur</label>
                    <p-inputNumber #champNbHeures  [(ngModel)]="ajustement.nbKmsAvant" (keyup.enter)="creerReleveHeure()"></p-inputNumber>
                    <small class="p-error" *ngIf="submitted && !ajustement.nbKmsAvant">Le nombre de KM de l'ancien compteur est obligatoire.</small>
                </div>
                <div class="flex flex-column gap-2 col-12 md:col-6 lg:col-4">
                    <label for="chauffeur">Nb KM nouveau compteur</label>
                    <p-inputNumber #champNbHeures  [(ngModel)]="ajustement.nbKmsApres" (keyup.enter)="creerReleveHeure()"></p-inputNumber>
                    <small class="p-error" *ngIf="submitted && !ajustement.nbKmsApres && ajustement.nbKmsApres != 0">Le nombre de KM du nouveau compteur est obligatoire.</small>
                </div>
            </div>

            <div class="grid">
                <div class="col-12 text-right mt-3">
                    <button pButton pRipple label="Confirmer" icon="pi pi-save" class="p-button-primary"
                        (click)="confirmer()"></button>
                    <button pButton pRipple label="Annuler" icon="pi pi-ban" class="p-button-text"
                        (click)="annuler()"></button>
                </div>
            </div>

        </p-card>
    </div>

</div>